import Vue from "vue";

// ERP View
Vue.component("erp-view", require("@/components/layout/ErpView").default);
Vue.component("file-upload", require("@/components/files/FileUpload").default);

Vue.component(
  "dx-context-menu",
  require("devextreme-vue/context-menu").DxContextMenu
);


// DXGRID

Vue.component("dx-data-grid", require("devextreme-vue/data-grid").DxDataGrid);
Vue.component("dx-column", require("devextreme-vue/data-grid").DxColumn);
Vue.component("dx-grid-button", require("devextreme-vue/data-grid").DxButton);
Vue.component(
  "dx-column-chooser",
  require("devextreme-vue/data-grid").DxColumnChooser
);
Vue.component(
  "dx-header-filter",
  require("devextreme-vue/data-grid").DxHeaderFilter
);
Vue.component("dx-filter-row", require("devextreme-vue/data-grid").DxFilterRow);
Vue.component(
  "dx-column-fixing",
  require("devextreme-vue/data-grid").DxColumnFixing
);
Vue.component("dx-scrolling", require("devextreme-vue/data-grid").DxScrolling);
Vue.component("dx-summary", require("devextreme-vue/data-grid").DxSummary);
Vue.component(
  "dx-group-panel",
  require("devextreme-vue/data-grid").DxGroupPanel
);
Vue.component("dx-group-item", require("devextreme-vue/data-grid").DxGroupItem);
Vue.component("dx-grouping", require("devextreme-vue/data-grid").DxGrouping);
Vue.component(
  "dx-toolbar-item",
  require("devextreme-vue/data-grid").DxToolbarItem
);
Vue.component(
  "dx-search-panel",
  require("devextreme-vue/data-grid").DxSearchPanel
);

Vue.component("dx-export", require("devextreme-vue/data-grid").DxExport);
Vue.component("dx-selection", require("devextreme-vue/data-grid").DxSelection);
Vue.component("dx-editing", require("devextreme-vue/data-grid").DxEditing);
Vue.component("dx-lookup", require("devextreme-vue/data-grid").DxLookup);
Vue.component("dx-total-item", require("devextreme-vue/data-grid").DxTotalItem);
Vue.component("dx-toolbar", require("devextreme-vue/data-grid").DxToolbar);
Vue.component("dx-toolbar-item",require("devextreme-vue/data-grid").DxToolbarItem);
Vue.component("dx-search-panel",require("devextreme-vue/data-grid").DxSearchPanel);

/// EDITORS
Vue.component("dx-tab-panel", require("devextreme-vue/tab-panel").DxTabPanel); 
Vue.component("dx-tag-box", require("devextreme-vue/tag-box").DxTagBox); 
Vue.component("dx-list", require("devextreme-vue/list").DxList); 
Vue.component("dx-tree-list", require("devextreme-vue/tree-list").DxTreeList); 
Vue.component("dx-tree-view", require("devextreme-vue/tree-view").DxTreeView); 
  
Vue.component("dx-item", require("devextreme-vue/tab-panel").DxItem);  
Vue.component("dx-button", require("devextreme-vue/button").DxButton);
Vue.component("dx-date-box", require("devextreme-vue/date-box").DxDateBox);
Vue.component(
  "dx-calendar-options",
  require("devextreme-vue/date-box").DxCalendarOptions
);
Vue.component("dx-text-box", require("devextreme-vue/text-box").DxTextBox);
Vue.component(
  "dx-select-box",
  require("devextreme-vue/select-box").DxSelectBox
);
Vue.component("dx-text-area", require("devextreme-vue/text-area").DxTextArea);
Vue.component(
  "dx-number-box",
  require("devextreme-vue/number-box").DxNumberBox
);
Vue.component("dx-check-box", require("devextreme-vue/check-box").DxCheckBox);


// VALIDATOR
Vue.component(
  "dx-validation-group",
  require("devextreme-vue/validation-group").DxValidationGroup
);
Vue.component("dx-validator", require("devextreme-vue/validator").DxValidator);
Vue.component(
  "dx-required-rule",
  require("devextreme-vue/validator").DxRequiredRule
);
//kebab-case
Vue.component("dx-string-length-rule", require("devextreme-vue/validator").DxStringLengthRule);

Vue.component("dx-range-rule", require("devextreme-vue/validator").DxRangeRule);
Vue.component("dx-popup", require("devextreme-vue/popup").DxPopup);

const req = require.context("./views/", true, /\.(js|vue)$/i);
req.keys().map(key => {
  const name = key.match(/\w+/)[0];
  Vue.component(name, req(key).default);
});
 
const popups = require.context("./views/popup", true, /\.(js|vue)$/i);
popups.keys().map(key => {
  const name = key.match(/\w+/)[0];
  Vue.component(name, popups(key).default);
});
 
const clisses = require.context("./views/forms", true, /\.(js|vue)$/i);
clisses.keys().map(key => {
  const name = key.match(/\w+/)[0];
  Vue.component(name, clisses(key).default);
});

const troquel = require.context("./views/tabs", true, /\.(js|vue)$/i);
troquel.keys().map(key => {
  const name = key.match(/\w+/)[0];
  Vue.component(name, troquel(key).default);
});